import { authToken, TdApiRoutes } from '@td/api';
import {
  FETCH_CLINICAL_MEDICATIONS,
  FETCH_CLINICAL_MEDICATIONS_START,
  FETCH_CLINICAL_MEDICATIONS_SUCCESS,
  FETCH_CLINICAL_MEDICATIONS_FAIL,
  FETCH_MEDICATION_LIST_START,
  FETCH_MEDICATION_LIST_FAIL,
  FETCH_MEDICATION_LIST_REQUEST,
  FETCH_MEDICATION_LIST_SUCCESS,
  SET_SELECTED_MEDICATION,
  RESET_MEDICATION_LIST
} from './action-types';

export const fetchClinicalMedicationsStart = () => ({
  type: FETCH_CLINICAL_MEDICATIONS_START
});

export const fetchClinicalMedicationsSuccess = payload => ({
  type: FETCH_CLINICAL_MEDICATIONS_SUCCESS,
  payload
});

export const fetchClinicalMedicationsFail = error => ({
  type:    FETCH_CLINICAL_MEDICATIONS_FAIL,
  error:   true,
  message: error.message || 'Something went wrong'
});

export const fetchClinicalMedications = ({ memberId }) => {
  const endpoint = TdApiRoutes.member.clinicalMedicationsPath(memberId);
  const params   = { memberId };

  return {
    type:    FETCH_CLINICAL_MEDICATIONS,
    payload: { url: endpoint, params, token: authToken.get() }
  };
};

export const setSelectedMedication = medication => ({
  type: SET_SELECTED_MEDICATION,
  medication
});

export const resetMedicationList = () => ({
  type: RESET_MEDICATION_LIST
});

export const fetchMedicationList = term => ({
  type:    FETCH_MEDICATION_LIST_REQUEST,
  payload: { term }
});

export const fetchMedicationListStart = () => ({
  type: FETCH_MEDICATION_LIST_START
});

export const fetchMedicationListSuccess = data => ({
  type:    FETCH_MEDICATION_LIST_SUCCESS,
  payload: data
});

export const fetchMedicationListFail = error => ({
  type:    FETCH_MEDICATION_LIST_FAIL,
  error:   true,
  message: error.message || 'Something went wrong'
});
